import axios from "axios";
import authConfig from "./authConfig";
import { authTokenManager } from "./authTokenManager";
import store from "@/store";

const check_error_codes = (error_code) => {
  return authConfig.ERROR_CODES_FOR_REFRESH.includes(error_code);
};

// Creazione istanza axios con baseURL centralizzato dall'env (authConfig.BACK_LINK)
export const axiosWrapper = axios.create({
  baseURL: authConfig.BACK_LINK?.replace(/\/$/, '')
});

if(!axiosWrapper.defaults.baseURL){
  console.warn('[axiosWrapper] baseURL non definito, verrà usato fallback http://localhost:8080');
  axiosWrapper.defaults.baseURL = 'http://localhost:8080';
}

console.log('[axiosWrapper] baseURL =', axiosWrapper.defaults.baseURL);

axiosWrapper.interceptors.request.use(
  async (config) => {
    const token = await authTokenManager.getAccessToken();
    if (token) {
      const authHeader = authConfig.getAuthHeader(token);
      if (config.headers != undefined)
        config.headers[Object.keys(authHeader)[0]] = authHeader[Object.keys(authHeader)[0]];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosWrapper.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    const error_status = error.response?.status;
    const is_auth_error = check_error_codes(error_status);

    if (is_auth_error && originalRequest.url === `${authConfig.BACK_LINK}${authConfig.REFRESH_TOKEN_ROUTE}`) {
      // Clear tokens and redirect to login
      authTokenManager.clear();
      store.commit("auth/SET_AUTH_STATUS", false); // Aggiorna Vuex: utente disconnesso
      return Promise.reject(error);
    }

    if (is_auth_error && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = authTokenManager.getRefreshToken();
      const authHeader = authConfig.getAuthHeader(refreshToken);
      return axiosWrapper
        .post(`${authConfig.BACK_LINK}${authConfig.REFRESH_TOKEN_ROUTE}`, {}, {
          headers: authHeader,
        })
        .then(async (res) => {
          if (res.status === 200) {
            let token = res.data[authConfig.RESPONSE_JSON_ACC_TOKEN_KEY];
            await authTokenManager.setAccessToken(token);
            const authHeader = authConfig.getAuthHeader(token);
            axios.defaults.headers.common[Object.keys(authHeader)[0]] = authHeader[Object.keys(authHeader)[0]];
            return axiosWrapper(originalRequest);
          }
        })
        .catch((err) => {
          // Gestione della sessione scaduta se il refresh token fallisce
          return Promise.reject(err);
        });
    }

    return Promise.reject(error);
  }
);
